"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLineItemWidget = void 0;
var react_1 = __importDefault(require("react"));
var QuoteLineItemContext_1 = require("./QuoteLineItemContext");
var styles = __importStar(require("./QuoteLineItemWidget.css"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Quote/Types");
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var QuoteLineItemWidget = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    var _b = (0, QuoteLineItemContext_1.useQuoteLineItemContext)(), components = _b.components, item = _b.item, price = _b.price, actions = _b.actions, id = _b.id;
    var itemCostField = item.customFields.find(function (f) { return f.id === Types_1.ReservedFieldIds.Item && f.type === "currency"; });
    var itemQuantityField = item.customFields.find(function (f) { return f.id === Types_1.ReservedFieldIds.Quantity && f.type === "number"; });
    var quoteCurrencyFormatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    var prices = Object.entries(price);
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, styles.wrapper) }),
        react_1.default.createElement("div", { contentEditable: false },
            react_1.default.createElement("div", null, "Quote Line Item"),
            components.OptionsMenu && (react_1.default.createElement("div", { contentEditable: false, "data-interactive-zone": true, className: styles.options },
                react_1.default.createElement(components.OptionsMenu, null)))),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", padding: "l" },
            item.selection.mode === "optional" && (react_1.default.createElement("div", { "data-interactive-zone": true },
                react_1.default.createElement(kaleidoscope_1.Checkbox, { checked: item.selection.selected, labelHidden: true, role: item.selection.singleSelect ? "radio" : undefined, id: "line-item-".concat(id, "-selected"), label: "Select line item", size: "m", onChange: function () {
                        actions.toggleItemSelected();
                    }, className: styles.checkbox({
                        singleSelect: item.selection.singleSelect,
                    }) }))),
            react_1.default.createElement("div", { className: styles.descriptionWrapper }, children),
            !!itemCostField && (react_1.default.createElement("div", { "data-interactive-zone": true, contentEditable: false },
                react_1.default.createElement(components.CurrencyField, { field: itemCostField }))),
            !!itemQuantityField && (react_1.default.createElement("div", { "data-interactive-zone": true, contentEditable: false },
                react_1.default.createElement(components.NumberField, { field: itemQuantityField }))),
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", align: "end" }, prices.map(function (_a) {
                var _b;
                var _c = __read(_a, 2), frequency = _c[0], value = _c[1];
                return (react_1.default.createElement(kaleidoscope_1.Stack, { key: frequency, align: "end", gap: "xxs" },
                    prices.length > 1 && (react_1.default.createElement("div", { className: styles.frequencyPill },
                        react_1.default.createElement(kaleidoscope_1.Label, { size: "s", secondary: true }, frequency === "one-off" ? "One time" : "Recurring"))),
                    react_1.default.createElement(kaleidoscope_1.Text, null,
                        quoteCurrencyFormatter.format((_b = value === null || value === void 0 ? void 0 : value.quoted) !== null && _b !== void 0 ? _b : 0),
                        frequency !== "one-off" &&
                            " / ".concat((0, Recurrence_1.mapRecurringFrequencyToStaticPerLabel)(frequency)))));
            })))));
};
exports.QuoteLineItemWidget = QuoteLineItemWidget;
